import React from "react";
import { OverlayTrigger, Tooltip } from "react-bootstrap";

interface TruncatedTextCellProps {
  text: string | null | undefined;
  maxWidth?: string;
  minWidth?: string;
  maxLines?: number;
  rowIndex?: number;
  tooltipId?: string;
  fallbackText?: string;
}

const TruncatedTextCell: React.FC<TruncatedTextCellProps> = ({
  text,
  maxWidth = "300px",
  minWidth,
  maxLines = 4,
  rowIndex = 0,
  tooltipId,
  fallbackText = "-",
}) => {
  const displayText = text || fallbackText;
  const tooltipText = text && text !== fallbackText ? text : "";
  const uniqueId = tooltipId || `truncated-text-tooltip-${rowIndex}`;

  return (
    <OverlayTrigger
      placement="top"
      overlay={<Tooltip id={uniqueId}>{tooltipText}</Tooltip>}
    >
      <div
        className="truncated-text-cell-wrapper"
        style={{
          maxWidth: maxWidth,
          ...(minWidth && { minWidth: minWidth }),
          display: "-webkit-box",
          WebkitBoxOrient: "vertical",
          WebkitLineClamp: maxLines,
          overflow: "hidden",
          wordWrap: "break-word",
          overflowWrap: "break-word",
        }}
      >
        {displayText}
      </div>
    </OverlayTrigger>
  );
};

export default TruncatedTextCell;
